module.exports = __webpack_public_path__ + "img/714.317fce56.png";